import React from 'react';

import { isMobileDevice } from './Utils';
import sessionKit from './SessionKit';
import EVMWalletAPI from './EVMWalletAPI';
import EVMSession from './EVMSession';

export const SharedStateContext = React.createContext();

export const SharedStateProvider = (props) => {
    const [state, setState] = React.useState({
        antelopeSession: undefined,
        evmSession: undefined,
        token: undefined
    });

    const isLoggedIn = React.useMemo(
        () => (!!(state.antelopeSession || state.evmSession?.isNetworkSupported)),
        [state.antelopeSession, state.evmSession]
    );

    const updateState = (newProps) => {
        setState(prevState => ({...prevState, ...newProps}));
    };

    const loginWharf = async () => {
        const response = await sessionKit.login();
        updateState({antelopeSession: response.session});
    };

    const loginMetaMask = async () => {
        if (window.ethereum) {
            const walletAPI = new EVMWalletAPI(window.ethereum);
            const selectedAddress = await walletAPI.getSelectedAddress();

            if (selectedAddress) {
                const chainID = await walletAPI.getChainID();
                const evmSession = new EVMSession(walletAPI, selectedAddress, chainID);
                updateState({evmSession});
            }
        }
        else if (isMobileDevice()) {
            window.open("https://metamask.app.link/dapp/create-token.netlify.app"); // Alternatively: dapp://create-token.netlify.app
        }
        else {
            alert('MetaMask not detected');
        }
    };

    const logout = () => {
        if (state.antelopeSession) {
            sessionKit.logout(state.antelopeSession);
        }
        
        updateState({
            antelopeSession: undefined,
            evmSession: undefined,
            token: undefined
        });
    };

    const sharedValues = [
        state,
        {updateState, isLoggedIn, loginWharf, loginMetaMask, logout}
    ];

    return (
        <SharedStateContext.Provider value={sharedValues}>{props.children}</SharedStateContext.Provider>
    );
};
